import jwtDecode from 'jwt-decode';

import { PRODUCT_ID } from '@/config/auth.config';

import { IFRAME_MESSAGE_TYPES } from '@/config/iframe.config';
import { getAccessToken } from './token.utils';
import { EnvUtils } from '../env.utils';

export class LocationUtils {

  static async getUserId() {
    if (EnvUtils.isDevelopment()) {
      return;
    }
    const tokenString = await getAccessToken();
    const parsedUserId = jwtDecode<{ acid: string }>(tokenString);
    return parsedUserId?.acid ?? null;

  }

  static async setCurrentLocationToWorkspace(url: string, instanceName?: string | null) {
    const userIdFromToken = await LocationUtils.getUserId();
    const workspaceUrl = await LocationUtils.getWorkspaceUrl();
    const targetOrigin = new URL(workspaceUrl).origin;

    const iframeEvent = {
      type: IFRAME_MESSAGE_TYPES.LOCATION_CHANGED,
      url: url,
      featureName: 'Contracts And Billing',
      instanceName: instanceName,
      breadcrumb: null,
      userId: userIdFromToken,
      productId: PRODUCT_ID

    };
    window?.parent?.postMessage(JSON.stringify(iframeEvent), targetOrigin);
  }

  static getWorkspaceUrl() {
    return new Promise<URL>((resolve) => {
      try {
        function getCurrentURLMessageCallback(event: MessageEvent) {
          if (!event.origin) return;
          if (event?.data?.agCurrentURL) {
            window.removeEventListener('message', getCurrentURLMessageCallback);
            const url: URL = new URL(event.data.agCurrentURL);
            resolve(url);
          }
        }
        const message = {
          type: IFRAME_MESSAGE_TYPES.GET_WORKSPACE_CURRENT_URL
        };
        window.addEventListener('message', getCurrentURLMessageCallback);
        window?.parent?.postMessage(JSON.stringify(message), '*');
      } catch (error) {
        console.error(error);
      }
    });
  }
}
